import styled from '@emotion/styled'

import { IconArrow } from 'component-library/icons/IconArrow/IconArrow'
import { colors } from 'component-library/__styling/settings'
import { calcRem } from 'component-library/__styling/style-functions'
import { theme } from 'component-library/themes/perthnow/theme'
import { themedValue } from 'component-library/__styling/themed-value'

export const StyledButton = styled('button', theme)(
    {
        width: '100%',
        padding: calcRem(10),
        fontWeight: 700,
        textTransform: 'uppercase',
        textAlign: 'center',
        color: colors.white,
        border: 'none',
    },
    ({ theme }) => ({
        background: themedValue(theme, {
            thewest: section => section.primaryColor,
            perthnow: colors.perthnow.redRuby,
            fallback: colors.sevennews.red,
        }),
        '&:hover, &:focus': {
            background: themedValue(theme, {
                thewest: colors.thewest.greyGorilla,
                perthnow: colors.perthnow.blueKyanite,
                fallback: colors.sevennews.toreaBay,
            }),
        },
    })
)

export const StyledIconArrow = styled(IconArrow)({
    transform: 'rotate(90deg)',
    width: calcRem(10),
    height: calcRem(10),
    marginLeft: calcRem(5),

    '& path': {
        fill: colors.white,
    },
})
